export default defineAppConfig({
  title: "CryptoXChange",

  service: "https://beta.cryptoxchange.fr/api",
});
